
vouchers.service('VouchersModalService', function($modal, ApplicationService, ModelService){
    var result = {};
    result.initModal = function(item)
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/vouchers/partials/vouchersModal.html?v=" + versionNo,
            controller: "VouchersModalController",
            resolve: {
                item: function()
                {
                    return item;
                }
            }
        });
    }
    return result;
});
